/**
 * @name Carousel
 * @description Componente de imágenes en un carrusel
 * @author César Rivera
 */

import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

// Carousel Material-UI
import MuiCarousel from 'react-material-ui-carousel';

const Carousel = ({ items }) => {
  return (
    <Styled.CarouselCard
      indicators={true}
      animation="fade"
    >
      {items.map((item, index) => (
        <div key={index} style={{ height: '432px' }}>
          <Styled.CarouselImg url={item.URL} />
        </div>
      ))}
    </Styled.CarouselCard>
  );
};

Carousel.propTypes = {
  // URL de las imagenes del carrusel.
  items: PropTypes.array
};

// *************************************
// STYLED COMPONENTS                               
// *************************************

const Styled = {};

Styled.CarouselImg = styled.div`
  height: 100%;
  // width: 100%;
  border-radius: 6px;
  background-image: url(${(props) => props.url});
  background-size: contain;
  background-position: center;
  background-repeat: no-repeat;
`;

Styled.CarouselCard = styled(MuiCarousel)`
  height: 432px;
  border-radius: 6px;
  box-shadow: ${(props) => props.theme.shadows.depth2};

  .Carousel-indicators-4 {
    margin-top: -25px;
  }

  .Carousel-indicators-14 {
    margin-top: -25px;
  }
`;

export default Carousel;